<template>
  <div class="home">
    <carousel
      :scrollPerPage="true"
      :perPage="1"
      :autoplay="true"
      class="home-carousel"
    >
      <slide
        v-for="v in slides"
        v-bind:key="v._id"
      >
        <a
          :href="v.link"
          target="_blank"
        >
          <img :src="v.imageUrl">
        </a>
      </slide>
    </carousel>
    <div class="container">
      <!-- <h3>Lorem ipsum</h3> -->
      <PropertyCardList v-bind:properties="properties"></PropertyCardList>
    </div>
  </div>
</template>

<style lang="scss">
.VueCarousel-pagination {
  position: absolute;
  bottom: 0;
  .VueCarousel-dot {
    background-color: white !important;
    opacity: 0.7;
    transition: all 0.2s;
    outline: none !important;
  }
  .VueCarousel-dot--active {
    opacity: 1;
  }
}
.home-carousel {
  padding-top: 31.25%;
  @media all and (max-width: 480px) {
    padding-top: 56.25%;
  }
  background-color: black;

  position: relative;
  .VueCarousel-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>

<style lang="scss" scoped>
.VueCarousel-slide {
  position: relative;
  background: white;
  color: #fff;
  font-family: Arial;
  font-size: 24px;
  text-align: center;
  // background-image: url(https://picsum.photos/1000/1000);
  background-size: cover;
  background-color: black;
  background-position: center;
  // height: 560px; //desktop
  height: 230px;
  img {
    width: 100%;
    height: auto;
    // object-position: 50% 50%;
    // object-fit: none;
  }
}

.label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.container {
  max-width: 1820px;
  margin: 0 auto;
  padding: 16px 60px 30px;
  @media all and (max-width: 768px) {
    padding: 16px 4vw 30px;
  }
  > h3 {
    color: rgb(72, 72, 72);
    font-size: 24px;
    text-align: left;
  }
}
</style>


<script>
// @ is an alias to /src
import PropertyCardList from "@/components/PropertyCardList.vue";
import axios from "axios";
export default {
  name: "home",
  data() {
    return {
      properties: [],
      slides: []
    };
  },
  mounted() {
    axios
      .get("https://api.topagentmo.com/api/advertisements")
      .then(res => res.data)
      .then(d => {
        this.slides = d;
      })
      .catch(e => null);

    axios
      .get("https://api.topagentmo.com/api/advertiseProperties")
      .then(res => res.data)
      .then(d => {
        this.properties = d;
      })
      .catch(e => null);
  },
  components: {
    PropertyCardList
  }
};
</script>
